(() => {
  const initialize = root => {
    root.querySelectorAll('[data-rf-carousel]').forEach(carousel => {
      if (carousel.dataset.rfReady) return;
      carousel.dataset.rfReady = 'true';
      const slides = [...carousel.querySelectorAll('[data-rf-slide]')];
      const dots = [...carousel.querySelectorAll('[data-rf-dot]')];
      let active = 0;
      const show = index => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== active; slide.classList.toggle('is-active', i === active); });
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === active)));
      };
      carousel.querySelector('[data-rf-prev]')?.addEventListener('click', () => show(active - 1));
      carousel.querySelector('[data-rf-next]')?.addEventListener('click', () => show(active + 1));
      dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
      carousel.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') { show(active + 1); event.preventDefault(); }
        if (event.key === 'ArrowLeft') { show(active - 1); event.preventDefault(); }
      });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.rf-header details[open]').forEach(menu => { menu.open = false; menu.querySelector('summary')?.focus(); });
  });
  document.addEventListener('click', event => document.querySelectorAll('.rf-header details[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; }));
})();
